import React, { useRef, useState } from "react"
import { useSelector } from "react-redux"
import FAQIconWhite from '../../../../../assests/header/icons/FAQ-icon-white.png'
import FAQIconDark from '../../../../../assests/header/icons/FAQ-icon-dark.png'
import useClickOutside from "../../../../../hooks/useClickOutside"
import FAQ from "../../HeaderDashboard/FAQ"
import IconHeaderBackground from "../IconHeaderBackground"
import classes from '../Icons.module.css'
import { onKeyDown } from "../../../../../service"


const FAQBtn = () => {

    const [showFAQ, setShowFAQ] = useState(false)
    const texts = useSelector(state => state.translate.texts);
    const popupRef = useRef(null);

    useClickOutside(popupRef, () => {
        setShowFAQ(false);
    });

    function open(e) {
        setShowFAQ(prevShowFAQ => !prevShowFAQ)
    }

    return (
        <div ref={popupRef} className={` ${!showFAQ ? classes.Icon : classes.OpenIconImg}`}>
            <img src={` ${showFAQ ? FAQIconDark : FAQIconWhite}`} alt='FAQIcon' className={classes.IconImg} onClick={(e) => open(e)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => open(e))} />
            {showFAQ && <IconHeaderBackground title={texts.FAQ} close={() => setShowFAQ(false)}> <FAQ /></IconHeaderBackground>}
        </div>
    )
}

export default FAQBtn